/**
 * Build-time kill switches for the big optional modules.
 *
 * These are read from the environment at build time, so flipping one needs a
 * redeploy of the frontend — not of the API. That is the point: when Zoom, the
 * gift card funnel or the B2B portal breaks, the module can be taken off the
 * site without reverting code or touching the backend.
 *
 * Default is ON. A flag only turns something off when the variable is the exact
 * string 'false', so a missing or malformed value can never dark-launch a
 * module that is supposed to be live.
 */

const isDisabled = (value) => String(value).trim().toLowerCase() === 'false';

// Only modules whose every entry point is actually gated live here. Adding a
// flag without wiring the links that lead into it just ships a dead route.
export const FEATURES = {
  giftCard: !isDisabled(import.meta.env.VITE_FEATURE_GIFT_CARD),
  b2b: !isDisabled(import.meta.env.VITE_FEATURE_B2B),
};

export default FEATURES;
